<template>
  <div>
    <div id="container"></div>
    <div id="content" class="info-window-content" v-if="activeAoi">
      <div class="content-name">{{ activeAoi.name || "" }}</div>
      <div v-if="activeAoi.address" class="content-address">
        {{ activeAoi.address || "" }}
      </div>
      <div v-if="activeAoi.businessHours" class="content-hours">
        {{ activeAoi.businessHours || "" }}
      </div>
      <div v-if="activeAoi.serviceFee" class="content-hours">
        {{ activeAoi.serviceFee }}
      </div>
      <div v-if="activeAoi.telephone" class="content-mobile" @click="clickTel">
        <img :src="require('../imgs/phone_icon.png')" alt="" />
        {{ activeAoi.telephone || "" }}
      </div>
      <div class="content-mobile" @click="openMap">
        <img :src="require('../imgs/location_icon.png')" alt="" />{{
          TLang("获取路线", "brand")
        }}
      </div>
    </div>
  </div>
</template>

<script>
// import locationIcon from '../imgs/location_icon.png';
const locationIcon = require("../imgs/location_icon.png");
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  name: "DFMap",
  props: {
    position: {
      type: Array,
      // default: [121.4737, 31.2303],
    },
    sourceData: {
      type: Array,
    },
    content: {
      type: String,
    },
    selAoi: {
      type: Object,
    },
  },
  data() {
    return {
      aois: [],
      activeAoi: null,
      lastActiveAoiPosition: null,
      selCenter: null,
      show: false,
      map: null,
    };
  },

  watch: {
    selAoi(nval, oval) {
      if (nval && nval.longitude && nval.latitude) {
        const position = [nval.longitude, nval.latitude];
        this.selCenter = position;
        this.activeAoi = this.selAoi;
        this.map.setZoomAndCenter(13, position);
        // this.map.setZoom(13);
        // this.map.panTo(position, 200);
        // this.map.setCenter(position);

        setTimeout(() => {
          this.showInfoWindow(position);
          this.lastActiveAoiPosition = position;
        }, 400);
      }
    },
    // buyGoodsList(oval, nval) {
    //   if (!nval) return null;
    //   if (oval == nval) return;
    //   this.loadding = false;
    //   Loading.hide();
    // },
    // notSaleGoodsList: {
    //   handler(oldVal, newVal) {
    //     this.checkIsShowGoodsTip();
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    //DOM初始化完成进行地图初始化
    this.initMap();
  },
  methods: {
    initMap() {
      const _this = this;
      AMapLoader.load({
        key: "8b430b10314aee6969f5154724c52697", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 14, //初始化地图级别
            // center: this.selCenter, //初始化地图中心点位置
            dragEnable: true,
            zoomSpeed: 0.5,
            animateEnable: false,
          });

          // 创建 AMap.Icon 实例：
          var icon = new AMap.Icon({
            size: new AMap.Size(24, 24), // 图标尺寸
            image: require("../imgs/position_icon.png"), // Icon的图像
            // imageOffset: new AMap.Pixel(0, -20),  // 图像相对展示区域的偏移量，适于雪碧图等
            imageSize: new AMap.Size(24, 24), // 根据所设置的大小拉伸或压缩图片
          });

          this.sourceData.forEach((item, index) => {
            // const markerContent = document.getElementById("marker" + index);
            // markerContent.style.display = 'block';
            if (item.latitude && item.longitude) {
              const position = [item.longitude, item.latitude];
              const marker = new AMap.Marker({
                position: position,
                // icon: '../imgs/location_icon.png',
                icon: icon,
                // content: markerContent, // 将 html 传给 content
                offset: new AMap.Pixel(-13, -40), // 以 icon 的 [center bottom] 为原点
              });
              marker.on("click", function(ev) {
                // 触发事件的对象
                // 触发事件的地理坐标，AMap.LngLat 类型
                _this.activeAoi = item;
                _this.show = !_this.show;
                setTimeout(() => {
                  if (
                    _this.infoWindow &&
                    _this.infoWindow.getIsOpen() &&
                    _this.lastActiveAoiPosition === position
                  ) {
                    _this.infoWindow.close();
                  } else {
                    _this.showInfoWindow(position);
                  }
                  _this.lastActiveAoiPosition = position;
                }, 0);
              });
              this.map.add(marker);
              this.map.setFitView();
            }
          });
          // // 绑定事件
          this.map.on("click", function(ev) {
            _this.infoWindow.close();
            // 触发事件的对象
            // var target = ev.target;
            // // 触发事件的地理坐标，AMap.LngLat 类型
            // var lnglat = ev.lnglat;
            // // 触发事件的像素坐标，AMap.Pixel 类型
            // var pixel = ev.pixel;
            // // 触发事件类型
            // var type = ev.type;
            // console.log("ev",lnglat);
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    showInfoWindow(center) {
      // 信息窗体的内容
      // var content = [
      //     "电话 : 010-84107000   邮编 : 100102",
      //     "地址 : 北京市望京阜通东大街方恒国际中心A座16层</div></div>"
      // ];
      if (!this.infoWindow) {
        const content = document.getElementById("content");
        // 创建 infoWindow 实例
        this.infoWindow = new AMap.InfoWindow({
          content: content, //传入 dom 对象，或者 html 字符串
          // isCustom: true,
          anchor: 'bottom-left',
          offset: new AMap.Pixel(0, -50),
        });
      }

      // 打开信息窗体
      this.infoWindow.open(this.map, center);
    },

    onMarkerClick(p) {
      // 显示的再次点击取消显示 不显示的点击后显示
      if (this.activeAoi && this.activeAoi.id === p.id) {
        this.activeAoi = null;
      } else {
        this.activeAoi = p;
      }
    },
    clickHandler(e) {
      console.log("e", e);
      // alert('您在[ '+e.lnglat.getLng()+','+e.lnglat.getLat()+' ]的位置点击了地图！');
    },
    openMap() {
      const { longitude, latitude } = this.activeAoi;
      const url =
        "https://uri.amap.com/marker?position=" +
        longitude +
        "," +
        latitude +
        "&name=" +
        encodeURIComponent(this.activeAoi.address) +
        "&callnative=1";
      // let url = "";
      // switch (mapType) {
      //   case "腾讯地图":
      //     url =
      //       "https://apis.map.qq.com/uri/v1/marker?marker=coord:" +
      //       latitude +
      //       "," +
      //       longitude +
      //       ";addr:" +
      //       showMapData.address +
      //       ";title:地址&referer=keyfree";
      //     break;
      //   case "高德地图":
      // url =
      //   "https://uri.amap.com/marker?position=" +
      //   longitude +
      //   "," +
      //   latitude +
      //   "&name=" +
      //   showMapData.address +
      //   "&callnative=1";
      //     break;
      //   case "百度地图":
      //     url =
      //       "http://api.map.baidu.com/marker?location=" +
      //       latitude +
      //       "," +
      //       longitude +
      //       "&title=地址&content=" +
      //       showMapData.address +
      //       "&output=html&src=webapp.reformer.appname&coord_type=gcj02";
      //     break;
      //   default:
      //     break;
      // }
      // setShowMap(false);
      window.open(url);
    },
    clickTel() {
      if (this.activeAoi && this.activeAoi.mobile) {
        window.location.href = `tel:${this.activeAoi.mobile}`;
      }
    },
    onDrag() {
      // this.activeAoi = null;
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>

<style lang="less" scoped>
#container {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 1126px;
  height: 500px;
  float: right;
}

.info-window-content {
  background: white;
  padding: 15px;
  width: 360px;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  opacity: 0.95;
  .content-name {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
  }
  .content-address {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
  }
  .content-hours {
    margin-top: 5px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
  }
  .content-mobile {
    margin-top: 5px;
    font-size: 12px;
    font-weight: 400;
    color: #3d96e2;
    display: flex;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  }
  .custom-content-marker {
    width: 36px;
    height: 36px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
/deep/ .amap-info-content {
  padding: 0 !important;
}
</style>
